let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8EHDU")).then(() => parcelRequire('gDR9B'));